import React from "react";
import NetworkStatusBanner from './components/ui/NetworkStatusBanner';
import Routes from "./Routes";

function App() {
  return (
    <>
      <NetworkStatusBanner />
      <Routes />
    </>
  );
}

export default App;
